<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">
                                    جدول مهمانان سمینار {{ info . title }} - سانس شناسه #{{ $route . params . id }}
                                </h5>
                                <br>
                                <span>تعداد افراد دعوت شده : {{ total_count }}</span>

                                &nbsp;
                                &nbsp;
                                &nbsp;
                                <span>تعداد حاضرین : {{ present_count }}</span>

                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;
                                <a-button class="btn-outline" icon="plus" @click="isHidden2 = !isHidden2">
                                    افزودن دستی
                                </a-button>
                                &nbsp;
                                <UploadModal :seminar="info" @getData="getData"
                                    v-show="$root.hasPermission('/seminars/excel/')" />
                                &nbsp;

                            </a-col>


                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">

                        <div class="row">
                            <div class="col-md-6 my-1">
                                <label class="sr-only" for="inline-form-input-name">
                                    شماره همراه</label>
                                <b-form-input v-model="search.phone" id="inline-form-input-name" class="">
                                </b-form-input>
                            </div>

                            <div class="col-md-6 my-1">
                                <UserSearch @ids="getIds" />

                            </div>

                            <div class="col-md-2">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </div>
                        </div>



                    </b-card>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden2">
                        <form @submit.prevent="addGuest($event)">

                            <div class="row">
                                <div class="col-md-3 my-1">
                                    <label class="sr-only" for="inline-form-input-name">
                                        شماره همراه</label>
                                    <input type="text" name="phone" v-model="info2.phone" class="form-control">

                                </div>

                                <div class="col-md-3 my-1">
                                    <label>
                                        نام</label>
                                    <input type="text" name="name" v-model="info2.name" class="form-control">

                                </div>

                                <div class="col-md-3 my-1">
                                    <label>
                                        نام خانوادگی</label>
                                    <input type="text" name="family" v-model="info2.family" class="form-control">

                                </div>
                                <div class="col-md-3 my-1">
                                    <label>
                                        کد ملی</label>
                                    <input type="text" name="national_code" v-model="info2.national_code"
                                        class="form-control">

                                </div>

                                <div class="col-md-3 my-1">
                                    <UserSearch @ids="getCallerIds" />


                                </div>
                                <input type="hidden" name="sans_id" :value="$route.params.id">
                                <div class="col-md-7">
                                </div>
                                <div class="col-md-2">


                                    <button :disabled="loading" type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>

                                </div>
                            </div>



                        </form>
                    </b-card>

                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <div class="table-responsive">

                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">شناسه</th>
                                            <th scope="col">شماره موبایل</th>
                                            <th scope="col"> نام و نام خانوادگی</th>
                                            <th scope="col"> تماس گیرنده </th>
                                            <th scope="col"> تعداد همراه</th>
                                            <th scope="col"> توضیحات </th>
                                            <th scope="col"> حاضر در سمینار </th>
                                            <th scope="col"> ثبت نام مدعوین </th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in data">
                                            <th scope="row">#{{ row . id }}</th>
                                            <td>{{ row . phone }}</td>
                                            <td>


                                                <b-badge variant="light"
                                                    class="text-dark">{{ $root . full_name(row . name, row . family) }}</b-badge>
                                            </td>
                                            <td>
                                                <b-badge variant="light"
                                                    class="text-dark">{{ row . caller ? $root . full_name(row . caller . firstname, row . caller . lastname) : '' }}</b-badge>
                                            </td>
                                            <td>
                                                <div>
                                                    <a-badge style="padding:10px;" variant="light" class="text-dark">
                                                        {{ row . count }}
                                                    </a-badge>
                                                    <a-button-group>
                                                        <a-button :disabled="row.count < 1"
                                                            style="height:30px !important" @click="row.count --"
                                                            @click.stop="changeCount(row)">
                                                            <a-icon type="minus" />
                                                        </a-button>
                                                        <a-button :disabled="row.count > 99"
                                                            style="height:30px !important" @click="row.count ++"
                                                            @click.stop="changeCount(row)">
                                                            <a-icon type="plus" />
                                                        </a-button>
                                                    </a-button-group>
                                                </div>
                                            </td>
                                            <td> {{ row . description }}</td>
                                            <td>
                                                <a-switch
                                                    v-model="row.present == 1 ? row.present=true:row.present=false"
                                                    @change="changePresent(row.id)" />
                                            </td>
                                            <td>
                                                <div class="d-flex">
                                                    <GuestModal :data="row" :seminar="info"
                                                        @getData="getData"
                                                        v-show="$root.hasPermission('/seminars/contract/')" />
                                                    &nbsp;
                                                    <a-button @click="printCart(row.name+' '+row.family)"
                                                        class="btn-outline-primary" icon="idcard">
                                                        صدور کارت </a-button>
                                                    &nbsp;

                                                    <a-button @click="printContract(row)" class="btn-outline-primary"
                                                        icon="file">
                                                        قرارداد </a-button>
                                                    &nbsp;



                                                </div>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import GuestModal from '../../components/Seminars/ModalGuest.vue';
    import UploadModal from '../../components/Seminars/ModalUpload.vue';
    import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"
    import debounce from 'lodash/debounce';


    export default {
        components: {
            GuestModal,
            UploadModal,
            UserSearch
        },
        data() {
            this.changeCount = debounce(this.changeCount, 500);

            return {
                data: [],
                currentPage: 1,
                total: 0,
                total_count: 0,
                present_count: 0,
                isHidden: false,
                isHidden2: false,
                search: {
                    phone: "",
                    caller_id: []
                },
                info: {},
                info2: {},
                count: 5,
                loading:false

            };
        },
        methods: {
            async getSeminar() {
                let _this = this;
                await axios
                    .get("/seminars/single/" + this.$route.params.id + '?sans=1')
                    .then(function(response) {
                        _this.info = response.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            addGuest(event) {
                let _this = this;
                let data = new FormData(event.target);
                if (this.info2.caller_id != undefined) {
                    data.append('caller_id', this.info2.caller_id);
                }
                
                this.loading = true;
                axios
                    .post("/seminars/guests/add", data)
                    .then(function(response) {
                        _this.loading = false;
                        _this.$toast.success(" مهمان با موفقیت افزوده شد");
                        _this.info2 = {
                            'phone': "",
                            'name': "",
                            'family': "",
                            'national_code': ""
                        };
                        _this.getData();
                    })
                    .catch(function(err) {
                        _this.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            changeCount(row) {
                let _this = this;
                _this.$root.loading = true;
                let data = {
                    count: row.count
                };

                axios
                    .post("/seminars/guests/changeCount/" + row.id, data)
                    .then(function(response) {
                        _this.$root.loading = false;
                        _this.$toast.success("همراهان کاربر با موفقیت ویرایش شد   ");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });


            },
            getIds(value) {
                this.search.caller_id = value
            },
            getCallerIds(value) {
                this.info2.caller_id = value
            },
            async getData() {
                let _this = this;
                let url =
                    `/seminars/guests?page=${this.currentPage}&&phone=${this.search.phone}&&caller_id=${this.search.caller_id}&&sans_id=${this.$route.params.id}`;
                axios
                    .get(url)
                    .then(function(response) {
                        console.log(response)
                        _this.$store.state.loading = false;
                        _this.data = response.data.data.data;
                        _this.total = response.data.data.total;
                        _this.total_count = response.data.all_count;
                        _this.present_count = response.data.present_count;
                        _this.currentPage = response.data.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            async changeCalled(id) {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/guests/called/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async changePresent(id) {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/guests/present/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async changeAccepted(id) {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/guests/accepted/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            handleChange() {},
            showModal() {
                this.visible = true;
            },

            defaulProfit() {
                let choosedRole = this.roles.find(x => x.id == this.seminar_role);
                this.info.profit_percent = choosedRole.profit_percent;
                //    return this.roles.find(x => x.id == this.seminar_role);
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
            printCart(fullName) {

                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                    stylesHtml += node.outerHTML;
                }
                const WinPrint = window.open('', '',
                    'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

                WinPrint.document.write(`<!doctype html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>کارت مشترک - ${fullName}</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            border-style: none;
            direction: rtl;
        }


        .text-left {
            text-align: left;
        }

        .text-center {
            text-align: center;
        }

        #cart-box {
            width: 321px;
            height: 204px;
            margin: 0 auto;
            font-family: nazanin;
            position: relative;
        }

        #fullname {
            position: absolute;
            bottom: 38px;
            right: 25px;
            font-family: nazanin;
            font-weight: bold;
            font-size: 16px;
        }

    </style>
</head>
<body>
<div id="cart-box">
    <p id="fullname"> ${fullName}</p>
</div>
</body>
</html>
`);

                WinPrint.document.close();
                WinPrint.focus();
                WinPrint.print();
                WinPrint.close();
            },
            printContract(row) {

                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                    stylesHtml += node.outerHTML;
                }
                const WinPrint = window.open('', '',
                    'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

                WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    <style>
      
    </style>
  </head>
  <body style=" direction: rtl; padding-x: 40px; font-size:13px;">
    <container>
      <header>
        <div>
          <p style=" text-align: center;">بسمه تعالی</p>
        </div>
        <div style="display: flex;
        align-items: flex-end;
        flex-direction: column;">
          <div>
            شماره قرارداد : ${row.unique_id}
          </div>
          <div style="margin-top:10px;">
            ${new Date().toLocaleDateString('fa-IR')} : تاریخ
          </div>
        </div>
      </header>
      <div>
        <section>
          <h6>
            ماده ۱ - طرفین قرارداد
          </h6>
          <p>
            طرف اول شرکت آسان تهاتر ایرانیان (بامسئولیت محدود) به شماره ثبت ۵۳۰۲۱ با نمایندگی آقای محمد مرادی به نشانی تهران نلسون ماندلا نبش خیابان طاهری برج
مشکی (مرکزتجارت ایرانیان) طبقه ۷ واحد ۶ که از این پس در این قرارداد شرکت نامیده می شود.
<br>
طرف دوم آقای/خانم : ${row.name+' '+row.family} کدملی : ${row.national_code} موبایل : ${row.phone}
<br>
تلفن ثابت : ${row.tel} به نشانی : ${row.address}

          </p>
        </section>

        <section>
          <h6>
            ماده ۲ - موضوع قرارداد
          </h6>
          <p>
            عبارت است از صدور و فروش کارت رفاه خانواده و پذیرش عضویت طرف دوم قرارداد در سامانه تهاتر کالا و خدمات به منظور واگذاری کارت رفاه و گردشگری از طرف
شرکت به مشترک.
          </p>
        </section>

        <section>
          <h6>
            ماده ۳ - مدت قرارداد
          </h6>
          <p>
            از تاریخ ${new Date().toLocaleDateString('fa-IR')}  لغایت ${new Date(new Date().setFullYear(new Date().getFullYear() + 5)).toLocaleDateString('fa-IR')} اعتبار تعهدات مندرج در این قرارداد به مدت پنج سال شمسی می باشد و پس از این تاریخ قابل تمدید می باشد.

      
          </p>
        </section>

        <section>
          <h6>
            ماده ۴ - مبلغ قرارداد
          </h6>
          <p>
            مبلغ قرارداد ${row.amount} ریال می باشد که پس از واریزبه حساب طرف اول به عنوان مشترک نسبت به استفاده از تسهیلات مندرج مفاد قرارداد بهره مند می گردد.
            تبصره : در صورت افزایش واریزی در طول قرارداد از طرف مشترک مطابق شرایط مذکور در ماده ۵ اقدام می گردد.
      
          </p>
        </section>

        <section>
          <h6>
            ماده ۵ - شرایط قرارداد
          </h6>
          <p>
             ۵ - ۱
            در سایت شرکت ، تخصیص اعتبار تهاتر(امتیاز) تا یک سال به میزان ۶۰ درصد سالیانه به صورت روز شمار تضمین می نماید و پس از آن در صورت تمدید قرارداد
تغییر ضریب سایت شرکت جهت ادامه همکاری وبا شرایط جدید اعلام می گردد.
      
          </p>
          <br>

          <p>
            ۵ - ۲
             دارنده کارت به ازای مبلغ سرمایه گذاری مانده دستمزد شرکت در هر روز به صورت روز شمار اعتبار به صورت سالیانه برخوردار خواهد شده که امتیاز مذکوردر هر
روز به کارت مشترک اضافه می گردد.
         </p>
         <br>

         
         <p>
          ۵ - ۳
          امتیاز موجود در کارت به صورت اعتبار سالیانه و جوایز شرکت در حساب ایشان منظور گردیده قابلیت تبدیل به وجه رایج ودریافت نقدی نداشته و صرفامشترک می
تواند نسبت به امتیاز های باقی مانده (استفاده از خدمات اعلامی در سایت شرکت اقدام نمایید
)       </p>
       <br>

         
       <p>
        ۵ - ۴
         خرید هرگونه کالا یا خدمات اعلام شده در سایت ، بصورت نقدی همراه با تخفیف می باشد که مبلغ تخفیف باکسر از اعتبار / امتیاز موجود در آت کارت انجام می
        شود .اگر چه ممکن است شرکت برخی از کالا یا خدمات را با امکان بیش از پنجاه درصد در اختیار مشترکین قراردهد که این نوع کالا یا خدمات به صورت موقت و دائم
       . استثنا ارائه میگردد و بامعرفی شرکت در هر زمان و یا بدون اطلاع قبلی قابل حذف از محصولات می باشد
      </p>
     <br>

     <p>
      ۵ - ۵
       اعتبار و امتیازات مشترک قابل استرداد نمی باشد ولی این مبلغ و همچنین اعتبار و جوایز تخصیصی شرکت در طول مدت قرارداد تا تاریخ انقضای کارت امکان
      استفاده از خدمات شرکت را دارا می باشد.    </p>
   <br>
        </section>

        <section>
          <h6>
            ماده ۶ - سایر شرایط
          </h6>
          <p>این قرارداد مطابق توافق هر دو طرف و مستند به ماده ۱۰ قانون مدنی در ۷ ماده و ۱ تبصره منعقد و در دو نسخه تنظیم شده و در طول مدت این قرارداد الزام آور خواهد
            بود
          </p>
        </section>
      </div>
      <footer style=" display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-around;
      margin-top:30px">
        <div>
          مهر و امضا شرکت 
        </div>
        <div>
          امضامشتری
        </div>
      </footer>
    </container>
  </body>
</html>`);

                WinPrint.document.close();
                WinPrint.focus();
                WinPrint.print();
                WinPrint.close();
            }
        },
        mounted() {
            this.getData();
            this.getSeminar();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
